export default __webpack_public_path__ + "static/ringsticks-419dae231cbdd978a7733435200374d1.png";